function ProfileStats({ profile }) {
  const cars = profile?.garageCars || [];
  const buildCount = cars.length;
  const modCount = cars.reduce((total, car) => total + (Array.isArray(car.mods) ? car.mods.length : 0), 0);
  return <div style={statsStyle}><Stat value={buildCount} label={buildCount === 1 ? "Build" : "Builds"} /><Stat value={modCount} label={modCount === 1 ? "Mod" : "Mods"} /></div>;
}
function Stat({ value, label }) { return <div style={statStyle}><strong style={valueStyle}>{value}</strong><span style={labelStyle}>{label}</span></div>; }
const statsStyle = { display: "flex", alignItems: "center", gap: "10px", marginTop: "18px", fontSize: "14px" };
const statStyle = { display: "flex", minWidth: 0, minHeight: "58px", flex: "1 1 0", alignItems: "center", gap: "8px", padding: "10px 13px", border: "1px solid #303030", borderRadius: "12px", background: "#1d1d1d", boxSizing: "border-box" };
const labelStyle = { color: "#999", fontWeight: "700" };
const valueStyle = { color: "white", fontSize: "22px", fontWeight: "900" };
export default ProfileStats;
